import { render, staticRenderFns } from "./BusSelect.vue?vue&type=template&id=38afaae8&scoped=true&lang=html&"
import script from "./BusSelect.vue?vue&type=script&lang=js&"
export * from "./BusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afaae8",
  null
  
)

export default component.exports